export enum Segment {
    Commission = 'commission',
    AssetWealthPositions = 'asset-wealth-positions',
    AdvisorCode = 'advisor-code',
    AvenueCapturesCreation = 'avenue-captures-creation',
    AvenueCapturesPatch = 'avenue-captures-patch',
    FinancialGoals = 'financial-goals',
    CaptureGoals = 'capture-goals',
    SquadSegmentPair = 'squad-segment-pair',
    StructuredProductsRevenue = 'structured-products-revenue',
    BullOrdersCtvm = 'bull-orders-ctvm',
    Consorcio = 'consorcio',
    PrivateServices = 'private-services',
    Captures = 'captures',
    ListedFunds = 'listed-funds',
    MarketingData = 'marketing-data',
    BaseConsorcioCota = 'base-consorcio-data',
    ReunioesConsorcio = 'reunioes-consorcio',
    ReuniaoOffshore = 'reuniao-offshore',
    BaseCadastroMBFO = 'base-cadastro-mbfo',
    BaseCustodiaMBFO = 'base-custodia-mbfo',
    CambioProcess = 'cambio-process',
    OfficialRevenue = 'official-revenue',
    EmissoesPatrimoniais = 'emissoes-patrimoniais',
    AssetMotorTransactions = 'asset-motor-transactions',
    AssetMotorClasseTir = 'asset-motor-classe-tir',
    AssetMotorBancoTir = 'asset-motor-banco-tir',
    AssetMotorPositions = 'asset-motor-positions',
    AssetMotorHistoryReport = 'asset-motor-history-report',
    AssetMotorControlRisk = 'asset-motor-control-risk',
    AssetMotorReportTir = 'asset-motor-report-tir',
    ConsolidationMotor = 'consolidation-motor',
    WmRelatorioStatusExtrato = 'wm-relatorio-status-extrato',
    WmRelatorioStatusReports = 'wm-relatorio-status-reports',
    WmRelatorioStatus = 'wm-relatorio-status',
}
